import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { T } from 'react-translator-component';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../context/user';
import { format, parseISO } from 'date-fns';
import useBookable from '../../hooks/useBookable';
import { getLocale } from '../../functions';


const getTranslation = (key) => T(key);

const dateschema = Yup.object().shape({
    day: Yup.string()
        .required(() => getTranslation('yup.required')),
    hour: Yup.string()
        .required(() => getTranslation('yup.required')),
    qty: Yup.number()
        .required(() => getTranslation('yup.required'))
        .min(1, () => getTranslation("yup.minQty"))
});
const dateschemaAllDay = Yup.object().shape({
    day: Yup.string()
        .required(() => getTranslation('yup.required')),
    qty: Yup.number()
        .required(() => getTranslation('yup.required'))
        .min(1, () => getTranslation("yup.minQty"))
});

const DateSelector = ({ showDateSelector, setShowDateSelector, handleAddToCart, bookableItemId, showCancel = true, onCancel, showButtons = true, setDataReadyToCart }) => {


    const { language } = useContext(UserContext)
    const [availableHours, setAvailableHours] = useState([]);
    const [maxQty, setMaxQty] = useState(1);
    const [loading, setLoading] = useState(true);
    const { getSchedule } = useBookable();
    const [schedule, setSchedule] = useState([]);

    const [multiplyPrice, setMultiplyPrice] = useState(false);
    const [allDay, setAllDay] = useState(false);

    useEffect(() => {
        if (!bookableItemId) return;

        console.log('21feb - bookableItemId', bookableItemId);

        // TODO_G: Casos particulares
        if (bookableItemId == "63bf879d-aad3-43db-bc68-4eb61c717d61" || 
            bookableItemId == "c53dee2d-f751-4a16-beaa-45b76248f0ab" ||         // Housekeeping - linen change
            bookableItemId == "e7e08de4-1b33-4897-9aab-a084e3c5c65c"            // Housekeeping - In between cleaning
        ) {
            // Housekeeping - linen change
            setMultiplyPrice(true);
            formik.setFieldValue('multiplyPrice', true);
            setAllDay(true);
            formik.setFieldValue('allDay', true);
        } else {
            formik.setFieldValue('multiplyPrice', false);
            formik.setFieldValue('allDay', false);
        }

        setLoading(true);
        getSchedule(bookableItemId)
            .then(res => {

                // const res1 = [{ "date": "2025-01-22", "hours": [{ "slotHour": "18:00", "slotsAvailable": 4 }, { "slotHour": "19:00", "slotsAvailable": 4 }, { "slotHour": "20:00", "slotsAvailable": 4 }] }, { "date": "2025-01-23", "hours": [{ "slotHour": "18:00", "slotsAvailable": 4 }, { "slotHour": "19:00", "slotsAvailable": 4 }, { "slotHour": "20:00", "slotsAvailable": 4 }] }, { "date": "2025-01-24", "hours": [{ "slotHour": "18:00", "slotsAvailable": 4 }, { "slotHour": "19:00", "slotsAvailable": 4 }, { "slotHour": "20:00", "slotsAvailable": 4 }] }];
                // setSchedule(res1);

                setSchedule(res);
                setLoading(false);
            })
    }, [bookableItemId]);



    const handleDayChange = (e) => {
        const day = e.target.value;
        const selectedDaySchedule = schedule.find(d => d.date === day);
        if (selectedDaySchedule) {

            let filteredHours = selectedDaySchedule.hours.filter(hour => hour.available > 0);

            console.log('14feb - selectedDaySchedule', selectedDaySchedule);
            const today = format(new Date(), 'yyyy-MM-dd');
            if (today == selectedDaySchedule.date) {
                const minHour = parseInt(format(new Date(), 'HHmm'));
                filteredHours = filteredHours.map((item) => {
                    const timeInt = parseInt(item.slotHour.replace(":", ""));
                    console.log('14feb - ', timeInt);
                    return {
                        ...item,
                        disabled: timeInt < minHour ? 1 : 0
                    };
                });
            }
            setAvailableHours(filteredHours);
            formik.setFieldValue('hour', "");
            if (allDay && filteredHours.length > 0) {
                setMaxQty(filteredHours[0].maxPeople); // Me baso en el maxPeople del slot 0                
            } else {
                setMaxQty(null);
            }
        } else {
            setAvailableHours([]);
            setMaxQty(null);
        }
    };

    const handleHourChange = (e) => {
        formik.handleChange(e);
        const selectedHour = e.target.value;
        const selectedHourDetails = availableHours.find(hour => hour.slotHour === selectedHour);
        if (selectedHourDetails) {
            // setMaxQty(selectedHourDetails.slotsAvailable);
            setMaxQty(selectedHourDetails.available);
            formik.setFieldValue('qty', 1);
        }
    };

    const formik = useFormik({
        initialValues: {
            day: '',
            hour: '',
            qty: 1,
            allDay: allDay,
            multiplyPrice: multiplyPrice
        },
        validationSchema: allDay ? dateschemaAllDay : dateschema,

        onSubmit: (values) => {
            handleAddToCart(values.day, values.hour, values.qty, values.allDay, values.multiplyPrice);
            setShowDateSelector(false);
        },
    });

    useEffect(() => {
        if (!showButtons && setDataReadyToCart) {
            // Sólo para el caso de versión sin botones y funcionamiento mediante estado
            console.log('10feb data:::', {
                day: formik.values.day,
                hour: formik.values.hour,
                qty: formik.values.qty,
                allDay: formik.values.allDay,
                multiplyPrice: formik.values.multiplyPrice
            });

            if (formik.values.day !== "" && (allDay || formik.values.hour != "") && formik.values.qty != "") {
                // Si todos los campos están llenos, actualiza el estado externo con los datos
                setDataReadyToCart({
                    type: 'date-selector',
                    id: bookableItemId,
                    day: formik.values.day,
                    hour: formik.values.hour,
                    qty: formik.values.qty,
                    allDay: formik.values.allDay,
                    multiplyPrice: formik.values.multiplyPrice
                });
            } else {
                setDataReadyToCart(null)
            }
        }
    }, [formik.values]);


    if (!schedule) return null;



    return (
        <div style={{ display: showDateSelector ? 'block' : 'none' }} className={`custo__m-modal-container-date p-2 m-2 d-flex flex-column ${showDateSelector ? 'show' : ''}`}>
            {/* <div className="custom-modal-header-date">
                <h6 className="page-detail-subtitle text-center mt-0 p-2 border-bottom">{T('general.reservation')}</h6>
            </div> */}
            <p className='text-center' style={{ fontSize: '14px' }}>{T('general.select-date')}</p>
            <Form onSubmit={formik.handleSubmit}>

                <Form.Control type='hidden' name="allDay" value={formik.values.allDay} />
                <Form.Control type='hidden' name="multiplyPrice" value={formik.values.multiplyPrice} />

                <div className="flex-grow-1 d-flex">
                    <div className="custom-modal-body flex-grow-1 d-flex flex-column justify-content-end">
                        <Container className="service-booking-form font-size-sm py-1">
                            {!loading
                                ?
                                schedule.length === 0
                                    ?
                                    <p className="p-4 text-center">{T('general.no-schedule-available')}</p>
                                    :
                                    <>
                                        <Row style={{ marginBottom: '10px' }} className="mb-2 d-flex align-items-center">
                                            <Col xs={4}>
                                                {T('general.date')}
                                            </Col>
                                            <Col xs={8}>
                                                <Form.Control
                                                    as={'select'}
                                                    name="day"
                                                    value={formik.values.day}
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        handleDayChange(e);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                >
                                                    <option value="">{T('select...')}</option>
                                                    {schedule.map((d, didx) => (
                                                        <option key={didx} value={d.date}>{format(parseISO(d.date), "EEEE dd", { locale: getLocale(language) })}</option>
                                                    ))}
                                                </Form.Control>
                                                {formik.touched.day && formik.errors.day && (
                                                    <div className="error-message small text-danger mt-1 text-center">{formik.errors.day}</div>
                                                )}
                                            </Col>
                                        </Row>

                                        {!allDay && (
                                            <Row className="mb-2 d-flex align-items-center">
                                                <Col xs={4}>
                                                    {T('general.time')}
                                                </Col>
                                                <Col xs={8}>
                                                    <Form.Control
                                                        as={'select'}
                                                        name="hour"
                                                        value={formik.values.hour}
                                                        onChange={handleHourChange}
                                                        onBlur={formik.handleBlur}
                                                    >
                                                        <option value="">{T('select...')}</option>
                                                        {availableHours.map((e, idx) => (
                                                            <option key={idx} value={e.slotHour} disabled={!!e.disabled}>{`${e.slotHour}` + T("general.time-format")}</option>
                                                        ))}
                                                    </Form.Control>
                                                    {formik.touched.hour && formik.errors.hour && (
                                                        <div className="error-message small text-danger mt-1 text-center">{formik.errors.hour}</div>
                                                    )}
                                                </Col>
                                            </Row>
                                        )}

                                        {console.log('14feb - availableHours', availableHours)}
                                        
                                        {availableHours.length > 0 && maxQty > 1 && <Row className="d-flex align-items-center">
                                            <Col xs={4}>
                                                {T('general.qty')}
                                            </Col>
                                            <Col xs={8}>
                                                <Form.Control
                                                    as={'select'}
                                                    name="qty"
                                                    value={formik.values.qty}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    disabled={availableHours.length === 0}
                                                >
                                                    {[...Array(maxQty).keys()].map((i) => (
                                                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                                                    ))}
                                                </Form.Control>
                                                {formik.touched.qty && formik.errors.qty && (
                                                    <div className="error-message danger small">{formik.errors.qty}</div>
                                                )}
                                            </Col>
                                        </Row>}
                                    </>
                                :
                                <div className="w-100 text-center mt-4" >
                                    <div className="loading">
                                        <div className="spinner-border" role="status">
                                        </div>
                                    </div>
                                </div>
                            }
                        </Container>
                    </div>
                </div>
            </Form>

            {showButtons && (
                <Row className="d-flex align-items-end flex-grow-1 mt-10">
                    {showCancel && <Col xs={6} style={{ paddingRight: '5px' }}>
                        <Button
                            className='w-100'
                            size={'lg'}
                            variant={'secondary'}
                            type={'button'}
                            onClick={() => {
                                onCancel()
                                // setShowDateSelector(false)
                            }}
                        >
                            {T('general.cancel')}
                        </Button>
                    </Col>}
                    <Col xs={showCancel ? 6 : 12} style={{ paddingLeft: '5px' }}>
                        <Button
                            className='w-100'
                            size={'lg'}
                            variant={'success'}
                            onClick={() => {
                                formik.validateForm().then(() => {
                                    formik.handleSubmit();
                                });
                            }}
                        >
                            {T('general.reserve')}
                        </Button>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default DateSelector;
